// extracted by mini-css-extract-plugin
export default {"banner":"InformationBanners_banner","bannerIcon":"InformationBanners_bannerIcon","content":"InformationBanners_content"};